// ===================================================================
// CONFIGURATION — EDIT ONLY THIS BLOCK
// ===================================================================
const CONFIG = {
  shippingDate: "",       // "" = today, or "YYYY-MM-DD" for holidays
  locale: "de",           // fr/de/cs/en/it/es
  processingDays: 1,      // business days for processing
  minDeliveryDays: 1,     // min delivery days after processing
  maxDeliveryDays: 3      // max delivery days after processing
};
// ===================================================================

// Helper: Add N business days (skip weekends)
function addBusinessDays(date, days) {
  const result = new Date(date);
  let added = 0;
  while (added < days) {
    result.setDate(result.getDate() + 1);
    const day = result.getDay(); // 0=Sun, 6=Sat
    if (day !== 0 && day !== 6) added++;
  }
  return result;
}

// Helper: Format date
function formatDate(date, locale) {
  return new Intl.DateTimeFormat(locale, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  }).format(date);
}

// Determine shipping start date
let shippingStart;
if (CONFIG.shippingDate) {
  const [y, m, d] = CONFIG.shippingDate.split('-').map(Number);
  shippingStart = new Date(y, m - 1, d);
} else {
  const now = new Date();
  shippingStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
}

// Skip weekends
const startDay = shippingStart.getDay();
if (startDay === 0) shippingStart.setDate(shippingStart.getDate() + 1); // Sun → Mon
if (startDay === 6) shippingStart.setDate(shippingStart.getDate() + 2); // Sat → Mon

// Calculate dates
const orderDate = new Date();
const processingDate = addBusinessDays(shippingStart, CONFIG.processingDays);
const earliestDelivery = addBusinessDays(processingDate, CONFIG.minDeliveryDays);
const latestDelivery = addBusinessDays(processingDate, CONFIG.maxDeliveryDays);

// Format
const formattedOrder = formatDate(orderDate, CONFIG.locale);
const formattedProcessing = formatDate(processingDate, CONFIG.locale);
const formattedDelivery = `${formatDate(earliestDelivery, CONFIG.locale)} – ${formatDate(latestDelivery, CONFIG.locale)}`;

// Inject into DOM
document.addEventListener('DOMContentLoaded', () => {
  // Update existing estimated delivery text
  const estEl = document.getElementById('estimated-delivery');
  if (estEl) estEl.textContent = formattedDelivery;
  
  // Fill timeline if exists (using ID selectors)
  const orderEl = document.getElementById('date-order');
  const processingEl = document.getElementById('date-processing');
  const deliveryEl = document.getElementById('date-delivery');
  
  if (orderEl && processingEl && deliveryEl) {
    orderEl.textContent = formattedOrder;
    processingEl.textContent = formattedProcessing;
    deliveryEl.textContent = formattedDelivery;
  }
});

// Expose for debugging
window.deliveryEstimate = {
  orderDate,
  processingDate,
  earliestDelivery,
  latestDelivery,
  formattedDelivery
};